module.exports = __webpack_public_path__ + "images/emoji/fist.9de430a91d1aef40cd33.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/fist.png
// module id = qTt3
// module chunks = 13